<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>短途运输完成使用说明:<br>
					<span>1、单号构成规则:201201+DTYS+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交后开始结算。</span><br>
					<span class="red">3、费用明细=现金上交，则为收入类型，指上一单剩余现金本次上交公司情景。</span><br>
					<span>4、查询关键字:单号、车牌、开始日期、截至日期、装货点、客户姓名、司机、状态。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="pre_base_button">
				<button class="pre_btn_ok" @click="edit_mode('pass_sel')">费用结算</button>
			</template>
			<template slot="pre_tan_button">
				<button class="pre_btn_ok" @click="edit_mode('wz')">违章信息</button>
			</template>
			<template slot="pre_tan_button">
				<button class="pre_btn_ok" @click="edit_mode('wx')">维修信息</button>
			</template> -->
		</pre-base>
		<!-- <carwx ref="carwx"></carwx>
		<carwz ref="carwz"></carwz> -->
		<!-- <carover ref="carover"></carover> -->
	</div>
</template>

<script>
	import {
		GetShort
	} from '@/utils/localstore.js';

	import api from '@/utils/type.js';
	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_v2.vue"),
			// 'carwx': () => import("./tan_car_wx.vue"),
			// 'carwz': () => import("./tan_car_wz.vue"),
			// 'carover': () => import("./tan_car_over.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "trans_m_over",
					"title": "短途运输登记",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"isShowEdit": "0",
					"step": "0",
					"sel_action": 'exp_dtys_trans_short_m_over',
					"upd_action": 'exp30_dtys_trans_short_m',
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_dtys_trans_short_d',
					"d_upd_action": '_dtys_trans_short_d',
					"file_action": 'filemore',
					"p1": 'ys',
					"p2": 'dt',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "截至日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "装货地点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "客户姓名",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"sel": "6"
						},
						{
							"name": "司机姓名",
							"val": "",
							"key": "driver",
							"type": "text",
							"class": "long1",
							"sel": "7"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "8"
						}
					],
					"parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "客户姓名",
							"val": "",
							"key": "c_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_company",
							"sel_name": "",
							"p": "1",
							"x": "1",
							"r": '0',
							"w": '1'
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_car",
							"sel_name": "",
							"p": "1",
							"x": "1",
							"r": '0',
							"w": '1'
						},
						{
							"name": "司机姓名",
							"val": "",
							"key": "driver",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_driver",
							"sel_name": "",
							"p": "1",
							"x": "1",
							"r": '0',
							"w": '1'
						},
						{
							"name": "装箱日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1 ",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "起点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "终点",
							"val": "",
							"key": "e_addr",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "起点里程",
							"val": "",
							"key": "s_dis",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "终点里程",
							"val": "",
							"key": "e_dis",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "本趟公里",
							"val": "",
							"key": "sj_dis",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "货物名称",
							"val": "",
							"key": "item_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "3"
						},
						{
							"name": "重量",
							"val": "",
							"key": "item_weight",
							"type": "number",
							"class": "long1",
							"note": "单位公斤",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "3"
						},
						{
							"name": "单价",
							"val": "",
							"key": "item_price",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "3"
						},

						{
							"name": "气卡期初",
							"val": "",
							"key": "gas_start",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "气卡消费",
							"val": "",
							"key": "gas_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "气卡剩余",
							"val": "",
							"key": "gas_end",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "现金加气",
							"val": "",
							"key": "gas_xj",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "ETC消费",
							"val": "",
							"key": "etc_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "ETC现金",
							"val": "",
							"key": "etc_xj",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "油卡消费",
							"val": "",
							"key": "oil_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "现金购油",
							"val": "",
							"key": "oil_money",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "现金分配",
							"val": "",
							"key": "xj_start",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "现金消费",
							"val": "",
							"key": "xj_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "现金剩余",
							"val": "",
							"key": "xj_end",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "加水",
							"val": "",
							"key": "jia_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},
						{
							"name": "维修费",
							"val": "",
							"key": "wh_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},

						{
							"name": "罚款",
							"val": "",
							"key": "fk_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},
						{
							"name": "停车费",
							"val": "",
							"key": "tcf_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},


						{
							"name": "其他费用",
							"val": "",
							"key": "qt_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},
						{
							"name": "收入",
							"val": "",
							"key": "amount_in",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "支出",
							"val": "",
							"key": "amount_out",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "应收运费",
							"val": "",
							"key": "yf_amount",
							"type": "number",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "已收运费",
							"val": "",
							"key": "yf_ok",
							"type": "number",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "未收运费",
							"val": "",
							"key": "yf_no",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "6"
						},
						{
							"name": "利润",
							"val": "",
							"key": "amount",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "7"
						},
						{
							"name": "车挂",
							"val": "",
							"key": "car_gua",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_car_gua",
							"sel_name": "",
							"p": "1",
							"x": "1",
							"r": '0',
							"w": '1'
						}
					],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "客户名称"
						},
						{
							"name": "车头"
						},
						{
							"name": "车挂"
						},
						{
							"name": "司机"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "起点"
						},
						{
							"name": "终点"
						},
						{
							"name": "品名"
						},
						{
							"name": "重量"
						},
						{
							"name": "单价"
						},
						{
							"name": "运费"
						},
						{
							"name": "司机工资"
						},
						{
							"name": "起始里程"
						},
						{
							"name": "终点里程"
						},
						{
							"name": "本次里程"
						},
						{
							"name": "状态"
						},
						{
							"name": "气卡消费"
						},
						
						{
							"name": "气卡公斤"
						},
						{
							"name": "气卡单价"
						},
						{
							"name": "现金加气"
						},
						{
							"name": "ETC卡消费"
						},
						{
							"name": "ETC现金消费"
						},
						{
							"name": "油卡消费"
						},
						{
							"name": "现金购油"
						},
						{
							"name": "上期备用剩余"
						},
						{
							"name": "备用金分配"
						},
						{
							"name": "备用金消费"
						},
						{
							"name": "备用金剩余"
						},
						{
							"name": "加水"
						},
						{
							"name": "维修"
						},
						{
							"name": "罚款"
						},
						{
							"name": "停车费"
						},
						{
							"name": "其他费用"
						},
						{
							"name": "收入"
						},
						{
							"name": "公户支出"
						},
						{
							"name": "应收运费"
						}, {
							"name": "已收运费"
						}, {
							"name": "未收运费"
						},
						{
							"name": "利润"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "修改人"
						},
						// {
						// 	"name": "浏览地址"
						// },
						// {
						// 	"name": "存储地址"
						// },
						{
							"name": "修改时间"
						},
						{
							"name": "附件"
						},
					],
					"d_parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "pay_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_dt_pay",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "油卡卡号",
							"val": "",
							"key": "pay_no",
							"type": "text",
							"class": "long1",
							"note": "油卡消费必填",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "支付日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "支付类型",
							"val": "支出",
							"key": "pay_io",
							"type": "none",
							"list": [{
									"id": "1",
									"val": "收入"
								},
								{
									"id": "2",
									"val": "支出"
								}
							],
							"sel_name": "",
							"sel_val": {},
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "是否开票",
							"val": "",
							"key": "is_paper",
							"type": "select",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "公司支付",
							"val": "否",
							"key": "is_pay",
							"type": "none",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "pay_note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [
						{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						{
							"name": "油卡卡号"
						},
						{
							"name": "支付日期"
						},
						{
							"name": "支付|收入"
						},
						// {
						// 	"name": "是否开票"
						// },
						// {
						// 	"name": "公司已支付"
						// },
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},

						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});


			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: async function(type) {
				let sheet_no = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'sheet_no') {
						sheet_no = this.item[i].val;
					}
				}
				let res, o = {};
				o.sheet_no = sheet_no;

				let that = this;
				switch (type) {
					case 'wx':
						// 弹出修改明细，修改主窗口信息
						res = await this.Is_exists_something('car_is_Exists_wx', sheet_no)
						// this.refresh_data();
						// console.log(res);
						if (res.status == '0') {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							return;
						}
						this.$nextTick(function() {
							that.$refs['carwx'].showpop(o);
						});
						break;
					case 'wz':
						// 弹出修改明细，修改主窗口信息
						res = await this.Is_exists_something('car_is_Exists_wz', sheet_no)
						// this.refresh_data();
						// console.log(res);
						if (res.status == '0') {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							return;
						}
						this.$nextTick(function() {
							that.$refs['carwz'].showpop(o);
						});
						break;
					case 'pass_sel':
						this.$nextTick(function() {
							that.$refs['carover'].showpop();
						});
						break;
					default:
						this.$message({
							message: '单号=' + sheet_no + '编辑失败!操作=' + type + ' 未配置!',
							type: 'success'
						});
						break;
				}
			},
			Is_exists_something: function(action, temp_no) {
				let that = this;
				let d = [];
				d.push(temp_no);
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_Common(action, 0, '', d)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			}







		}
	};
</script>
<style>
</style>